export const isSizeAndWeightEmpty = (sw) => {
  // Helper function to check if an object or array is empty
  if (!sw) return true;
  const isFalsyOrEmpty = (value) => {
    if (Array.isArray(value)) return value.length === 0;
    return value == null || value === false || value === 0 || value === "";
  };

  // Check each key in the object
  for (let key in sw) {
    //add printOwner to the list of keys to ignore as it's currently defaulting to true in Core
    if (key === "incident" || key === "id" || key === "__typename" || key === "printOwner" || key === "printCarrier") continue;

    if (key === "axleGroups") {
      // Special handling for axleGroups
      for (let axleGroup of sw.axleGroups) {
        if (axleGroup.weight !== null && axleGroup.weight !== 0) return false;
        for (let axle of axleGroup.axles) {
          if (!isFalsyOrEmpty(axle.leftAxleWeight) || !isFalsyOrEmpty(axle.rightAxleWeight) || !isFalsyOrEmpty(axle.totalAxleWeight)) {
            return false;
          }
        }
      }
    } else {
      // General case
      if (!isFalsyOrEmpty(sw[key])) return false;
    }
  }

  return true;
}